import { __extends } from "tslib";
import { GetExportJobsRequest, GetExportJobsResponse } from "../models/models_0";
import { deserializeAws_restJson1GetExportJobsCommand, serializeAws_restJson1GetExportJobsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Retrieves information about the status and settings of all the export jobs for an application.</p>
 */
var GetExportJobsCommand = /** @class */ (function (_super) {
    __extends(GetExportJobsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetExportJobsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    GetExportJobsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "GetExportJobsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetExportJobsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetExportJobsResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetExportJobsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetExportJobsCommand(input, context);
    };
    GetExportJobsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetExportJobsCommand(output, context);
    };
    return GetExportJobsCommand;
}($Command));
export { GetExportJobsCommand };
//# sourceMappingURL=GetExportJobsCommand.js.map